/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.NotePanel";
        class NotePanelWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("NotePanelWidgetTypeClass.createInstance()");
                    return new NotePanelWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("NotePanelWidgetTypeClass._storeHtml()");
                    NotePanelWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("NotePanelWidgetTypeClass::constructor");
                if (NotePanelWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/NotePanel/note-panel.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.NotePanelWidgetTypeClass = NotePanelWidgetTypeClass;
        class NotePanelWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._instanceReady = false;
                this._displayPending = false;
                this._createNoteButton = null;
                this._refreshButton = null;
                this._stealthHideButton = null;
                this._collapseState = "Show";
                this._outerDiv = null;
                this._noteComponentContainer = null;
                this._noteComponentConfig = {};
                this._noteComponent = null;
                this._currentDoc = null;
                this._currentDocId = null;
                this._reactToSlots = [WPTNamespace.Utilities.PRIMARY_SLOT_KEY];
                this._lastReactedSlots = [];
                this.presentInstance = () => {
                    this._log.info("NotePanelWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = NotePanelWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._outerDiv = this._container.querySelector('div.widget');
                    this._noteComponentContainer = this._container.querySelector('#notesContainer');
                    this._widgets.setTitle(this._config, this._container.querySelector('#notePanelWidgetHeadingText'), 'STR_WPT_NOTES');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._createNoteButton = this._container.querySelector('#notePanelAddButton');
                    this._createNoteButton.addEventListener('click', this._createNote);
                    this._refreshButton = this._container.querySelector('#notePanelReload');
                    this._refreshButton.addEventListener('click', this._refreshNotes);
                    this._stealthHideButton = this._container.querySelector('#notePanelStealthButton');
                    this._stealthHideButton.addEventListener('click', this._stealthHide);
                    // Set up component
                    let config = this._config;
                    if (config.hasOwnProperty('DisplayOptions') && (config.DisplayOptions != null)) {
                        this._noteComponentConfig = config.DisplayOptions;
                    }
                    if (config.hasOwnProperty('CollapseState') && (config.CollapseState != null)) {
                        this._collapseState = config.CollapseState;
                    }
                    if (config.hasOwnProperty("ReactToSlots") && (config.ReactToSlots != null))
                        this._reactToSlots = config.ReactToSlots;
                    this._noteComponent = new Widgets.ComponentNotes(this._core, this._noteComponentContainer, this, this._noteComponentConfig);
                    this._noteComponent.ErrorCallback = this._callErrorHandler;
                    this._noteComponent.FailCallback = this._callFailedHandler;
                    this._noteComponent.present();
                    this._type.instanceReady(this.getHandle());
                    this._instanceReady = true;
                };
                this._callFailedHandler = (json) => {
                    this._log.info("NotePanelWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("NotePanelWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                };
                this._stealthHide = (event) => {
                    this._log.info("NotePanelWidgetInstanceClass._stealthHide()");
                    this._core.Functions.hideElement(this._outerDiv);
                };
                this.showNotesForDocument = (doc) => {
                    this._log.info("NotePanelWidgetInstanceClass.showNotesForDocument()");
                    this._currentDoc = doc;
                    this._currentDocId = null;
                    this._core.Functions.showElement(this._createNoteButton);
                    this._core.Functions.showElement(this._refreshButton);
                    this._clearErrors();
                    this._noteComponent.showNotesForDocument(doc);
                };
                this.showNotesForDocumentId = (doc) => {
                    this._log.info("NotePanelWidgetInstanceClass.showNotesForDocumentId()");
                    this._currentDoc = null;
                    this._currentDocId = doc;
                    this._core.Functions.showElement(this._createNoteButton);
                    this._core.Functions.showElement(this._refreshButton);
                    this._clearErrors();
                    this._noteComponent.showNotesForDocumentId(doc);
                };
                this.showNotes = (list) => {
                    this._log.info("NotePanelWidgetInstanceClass.showNotes()");
                    this._clearErrors();
                    this._core.Functions.hideElement(this._createNoteButton);
                    this._core.Functions.hideElement(this._refreshButton);
                    this._noteComponent.showNotes(list);
                };
                this.clearDisplay = () => {
                    this._log.info("NotePanelWidgetInstanceClass.clearDisplay()");
                    this._clearErrors();
                    this._currentDoc = null;
                    this._currentDocId = null;
                    this._noteComponent.clearDisplay();
                };
                this._createNote = (event) => {
                    this._log.info("NotePanelWidgetInstanceClass._createNote()");
                    this._noteComponent.createNoteInteractive();
                };
                this._refreshNotes = (event) => {
                    this._log.info("NotePanelWidgetInstanceClass._refreshNotes()");
                    if (this._currentDoc)
                        this._noteComponent.showNotesForDocument(this._currentDoc);
                    else if (this._currentDocId)
                        this._noteComponent.showNotesForDocumentId(this._currentDocId);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("NotePanelWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
            }
            activate(context) {
                this._log.info("NotePanelWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED:
                        let slots = this._reactToSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (slots.length > 0) {
                            if ((this._collapseState == "Stealth") && this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS) && context.Decloak)
                                this._core.Functions.showElement(this._outerDiv);
                            if (!this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS)) {
                                this.showNotesForDocumentId(context.ActivationID);
                                // only remember slots we react to
                                this._lastReactedSlots = slots;
                            }
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.NOTE_CREATED:
                        this.showNotesForDocumentId(context.ActivationID);
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DESELECTED:
                        let intersection = this._lastReactedSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (intersection.length > 0) {
                            this._lastReactedSlots = [];
                            this.clearDisplay();
                            if (this._collapseState == "Stealth")
                                this._core.Functions.hideElement(this._outerDiv);
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.REQUEST_TO_ADVERTISE:
                        let capabilityEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.RESPONSE_CAPABILITY_PUBLISHED);
                        capabilityEvent.ActivationID = 0;
                        capabilityEvent.PrimaryContext = ["NotePanel"];
                        capabilityEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(capabilityEvent);
                        break;
                }
            }
        }
        NotePanelWidgetInstanceClass.HtmlData = null;
        Widgets.NotePanelWidgetInstanceClass = NotePanelWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
